import styled from "styled-components";

export const MapImg = styled.img`
  width: 35px;
`;
